export * from "./dist/ngx-my-date-picker.module";
export * from "./dist/ngx-my-date-picker.input";
export * from "./dist/ngx-my-date-picker.component";
export * from "./dist/interfaces/my-date.interface";
export * from "./dist/interfaces/my-date-model.interface";
export * from "./dist/interfaces/my-input-field-changed.interface";
export * from "./dist/interfaces/my-calendar-view-changed.interface";
export * from "./dist/interfaces/my-date-range.interface";
export * from "./dist/interfaces/my-day-labels.interface";
export * from "./dist/interfaces/my-month-labels.interface";
export * from "./dist/interfaces/my-options.interface";
export * from "./dist/interfaces/my-weekday.interface";
export * from "./dist/interfaces/my-marked-date.interface";
export * from "./dist/interfaces/my-marked-dates.interface";
export * from "./dist/interfaces/my-default-month.interface";


//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/index.js
// module id = 1206
// module chunks = 10